// Canonical public origins of the markets that have their own domain root
// (default/US, AU, NZ). Derived from markets.js.
const { markets } = require('./markets');

const siteOrigins = Object.fromEntries(
    Object.values(markets)
        .filter((market) => market.pathPrefix === '')
        .map((market) => [market.key, market.origin])
);

module.exports = { siteOrigins };
